/**
 * @ngdoc function
 * @name myConsultApp.controller:MainCtrl
 * @description
 * # MainCtrl
 * Controller of the myConsultApp
 */
import angular from 'angular';

angular
  .module('myConsultApp')
  .controller(
    'findAPatientCtrl',
    (
      $rootScope,
      $scope,
      $location,
      crumble,
      $cookieStore,
      PetsService,
      PatientsService,
      UploadReceiptService,
      InvitationService,
      $filter,
      $timeout,
      blockUI,
      OrganizationsService,
      ManageOrganizationService,
    ) => {
      if ($scope.isAdminUser || $scope.isSuperUser) {
        $location.path('/admin');
      }
      $scope.crumble = crumble;
      crumble.update();

      /*
       *   Scope Variables
       */

      $scope.currentOrg = null;
      $scope.showNorecord = false;
      $scope.petsresults = [];
      $scope.resMsgStatus = true;
      $scope.has_error = false;
      $scope.output = '';
      $scope.field_type = '';
      $scope.sortType = 'owner__last_login'; // set the default sort type
      $scope.currentSort = 'owner__last_login';
      $scope.filterSort = '-owner__last_login';
      $scope.findpatientForm = { search: '' };
      $scope.findpatientForm.species = {};
      $scope.findpatientForm.species.dog = true;
      $scope.findpatientForm.species.cat = true;
      $scope.species = [1, 2];
      $scope.findpatientForm.isActive = {};
      $scope.findpatientForm.isActive.active = true;
      $scope.findpatientForm.isActive.archived = true;
      $scope.isActive = [1, 0];
      $scope.paginationData = [];
      $scope.sortReverse = true;
      $scope.searchParam = null;
      $scope.noSearchYet = true;

      /*
       *   Scope Methods
       */

      // Function created for resuse in filter also
      $scope.loadPetInfo = (search) => {
        let searchOrg;
        $scope.noSearchYet = false;
        if ($scope.organizationFilter === 'all') {
          $rootScope.adminPage = true;
          searchOrg = '';
        } else {
          searchOrg = $scope.organizationFilter;
          $rootScope.adminPage = $location.$$url.indexOf('/admin') > -1;

          if ($scope.isAdminUser && $scope.currentOrganization.id !== $scope.organizationFilter) {
            $rootScope.adminPage = true;
          }
        }
        PatientsService.getPatients(
          search,
          $scope.species.toString(),
          searchOrg,
          $scope.isActive.toString(),
          $scope.filterSort,
        ).then((response) => {
          $scope.petsresults = response.patients;
          $scope.paginationData = response;
          $scope.setOrganizationProviders();

          $scope.showNorecord = true;
          blockUI.stop();
        });
      };

      $scope.filterOrganization = (organizationFilter) => {
        $('.search-section').removeClass('has-error').find('.help-block').hide();
        $scope.noSearchYet = false;
        $scope.organizationFilter = organizationFilter;

        if (organizationFilter === 'all') {
          $scope.validateSearch();
        } else {
          $scope.findpatientForm.search = '';
          $scope.searchParam = $scope.findpatientForm.search;
          $scope.loadPetInfo($scope.searchParam);
        }
      };

      $scope.setOrganizationProviders = () => {
        $scope.petsresults.forEach((element) => {
          element.pet.organizationProviders = element.pet.association;
        });
      };

      // To show the setting saved message for 2 seconds in find a patient page.
      $scope.updatePetInfo = (petObj, field_type) => {
        if (petObj.id !== null) {
          // To avoid required validation for dogs with null value for declawed
          petObj.petprofile = {};
          if (petObj.petprofile.declawed === null) {
            delete petObj.petprofile.declawed;
          }
          const submitData = {
            pet: petObj,
          };
          $scope.field_type = field_type;

          PetsService.updatePet(petObj.id, submitData).then(
            () => {
              $scope.output = 'Changes have been saved.';
              $scope.has_error = false;

              $scope.resMsgStatus = false;
              $timeout(() => {
                $scope.resMsgStatus = true;
              }, 10000);
            },
            (response) => {
              const errors = response.data.patient;

              if (response.status === 409) {
                errors.mainError = response.data.patient.errors;
              } else {
                Object.keys(errors).forEach((key) => {
                  errors[key] = errors[key].toString();
                });
              }
              if (response.status !== 200) {
                $scope.output = 'Not saved. Try again.';
                $scope.has_error = true;

                $scope.resMsgStatus = false;
                $timeout(() => {
                  $scope.resMsgStatus = true;
                }, 10000);
              }
            },
          );
        }
      };

      $scope.goToOverview = (patient) => {
        $scope.setCurrentPet(patient.pet);
        $scope.setCurrentPetOwner(patient.pet_owner);
        $scope.getOwnerPets(patient.pet_owner.id);
      };

      $scope.goToEdit = (patient) => {
        $scope.setCurrentPet(patient.pet, false);
        $scope.setCurrentPetOwner(patient.pet_owner);
        $scope.getOwnerPets(patient.pet_owner.id);
        if ($scope.isAdminUser) {
          $location.path(`/admin/pets/manage-pets/edit/${patient.pet_owner.id}/${patient.pet.id}`);
        } else {
          $location.path(`/find-a-pet/edit/${patient.pet_owner.id}/${patient.pet.id}`);
        }
      };

      $scope.submitFindAPatient = (findpatientForm) => {
        $scope.noSearchYet = false;

        angular.forEach(findpatientForm.species, (_, key) => {
          const id = `#${key}`;
          if (document.getElementById(key)) {
            if (document.getElementById(key).checked) {
              const index = $scope.species.indexOf(parseInt($(id).val()));
              if (index <= -1) {
                $scope.species.push(parseInt($(id).val()));
              }
            } else {
              const index = $scope.species.indexOf(parseInt($(id).val()));
              if (index > -1) {
                $scope.species.splice(index, 1);
              }
            }
          }
        });
        if ($scope.isAdminUser) {
          angular.forEach(findpatientForm.isActive, (_, key) => {
            const id = `#${key}`;
            if (document.getElementById(key)) {
              if (document.getElementById(key).checked) {
                const index = $scope.isActive.indexOf(parseInt($(id).val()));
                if (index <= -1) {
                  $scope.isActive.push(parseInt($(id).val()));
                }
              } else {
                const index = $scope.isActive.indexOf(parseInt($(id).val()));
                if (index > -1) {
                  $scope.isActive.splice(index, 1);
                }
              }
            }
          });
        }
        blockUI.start('Loading...');
        $scope.searchParam = findpatientForm.search;
        $scope.loadPetInfo($scope.searchParam);
      };

      $scope.validateSearch = () => {
        $('.search-section').removeClass('has-error').find('.help-block').hide();
        if ($scope.organizationFilter === 'all') {
          if ($scope.findpatientForm.search.trim().length >= 2) {
            $scope.submitFindAPatient($scope.findpatientForm);
          } else {
            $('.search-section').addClass('has-error').find('.help-block').show();
          }
        } else {
          $scope.submitFindAPatient($scope.findpatientForm);
        }
      };

      $scope.goToPage = (pageURL) => {
        PatientsService.getPatientPage(pageURL).then((response) => {
          $scope.petsresults = response.patients;
          $scope.paginationData = response;
          $scope.setOrganizationProviders();
        });
      };

      $scope.breedFilter = (row) => {
        return $scope.filterBreed !== null ? row.breed === $scope.filterBreed.id : true;
      };

      $scope.setSort = (sort) => {
        const findpatientForm = $scope.findpatientForm;
        if ($scope.sortType === sort) {
          $scope.reverseSort();
        } else {
          $scope.sortType = sort;
          $scope.currentSort = sort.replace('-', '');
        }

        $scope.filterSort = $scope.sortReverse === true ? `-${sort}` : sort;
        angular.forEach(findpatientForm.species, (key) => {
          const id = `#${key}`;
          if (document.getElementById(key).checked) {
            const index = $scope.species.indexOf(parseInt($(id).val()));
            if (index <= -1) {
              $scope.species.push(parseInt($(id).val()));
            }
          } else {
            const index = $scope.species.indexOf(parseInt($(id).val()));
            if (index > -1) {
              $scope.species.splice(index, 1);
            }
          }
        });
        $scope.validateSearch();
      };

      $scope.reverseSort = () => {
        $scope.sortReverse = !$scope.sortReverse;
      };

      $scope.customSort = (patientObject) => {
        return 0;
      };

      $scope.getRegDate = (list, application) => {
        let date = null;

        angular.forEach(list, (value) => {
          if (value.name === application) {
            const regDate = new Date(value.registration_date.replace(' ', 'T')); // add T separate because Safari requires it
            date = $filter('date')(regDate, 'MM-dd-yyyy');
          }
        });

        return date;
      };

      $scope.invite = (email, platform) => {
        InvitationService.storeEmail(email);

        if (platform === 'pwl') {
          $location.path('/rewards');
        }
      };

      $scope.uploadReceipt = (user, pet) => {
        UploadReceiptService.storeData(user, pet);
        $location.url(`/rewards/receipt-upload?uid=${user.id}`);
      };

      /*
       *   Main
       */

      if ($scope.isAdminUser && $location.$$url.indexOf('/admin') > -1) {
        $scope.organizationFilter = 'all';
      } else {
        blockUI.start('Loading...');
        $scope.organizationFilter = $scope.currentOrganization.id;
        $scope.loadPetInfo(null);
      }

      $scope.filterBreed = null;

      // clear header of current selected pet
      $scope.setCurrentPet(null);

      angular.element('#refineBtn').click((e) => {
        e.preventDefault();
        $(this).find('.icon i').toggleClass('fa-minus');
        $(this).parent().parent().find('.refineFilters').toggleClass('expanded');
      });

      angular.element('.refineFilters ul li a').click((e) => {
        e.preventDefault();
        $(this).find('.icon i').toggleClass('fa-minus');
        $(this).parent().toggleClass('expanded');
      });

      angular.element('#closePopUp').click((e) => {
        e.preventDefault();
        if ($.easybox.isOpen()) {
          $.easybox.close();
        }
      });

      angular.element('a.lightbox').easybox({});

      angular.element('.search-section .help-block').hide();

      $scope.$on('$viewContentLoaded', () => {
        if ($rootScope.isSearchStarted === true) {
          $scope.findpatientForm.search = $rootScope.searchText;
          $scope.validateSearch();
          $rootScope.isSearchStarted = false;
        }
      });

      $rootScope.$on('searchEvent', (_, id) => {
        if (id === 'Pets') {
          $scope.findpatientForm.search = $rootScope.searchText;
          $scope.validateSearch();
        }
      });
    },
  );
